import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { getDateFormat } from 'services/Utils';
import { DATE_FORMAT } from 'constants/app-constants';
import './delivery-checking-report-to-print.scss';

const DeliveryCheckingReportToPrint = forwardRef((props, ref) => {
	const loginRedux = useSelector((state) => state.loginRedux);
	const { data } = props?.data || {};
	// const globalRedux = useSelector((state) => state.globalRedux);
	// const { voucherHeads = [] } = globalRedux;
	// const voucherHead = voucherHeads?.find((voucherHead) => voucherHead?._id === voucherHeadId);

	return (
		<div className="invoice-pdf-container" ref={ref}>
			<div style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '1rem' }}>Delivery Checking Report</div>
			<table cellPadding="0" cellSpacing="0">
				<tr>
					<td colSpan="3">
						<table border="1" className="top-heading">
							<tr
								style={{
									fontSize: '0.8rem',
									fontWeight: 'bold',
								}}>
								<td colSpan="3" style={{ padding: 0 }}>
									<table>
										<tr>
											<td
												style={{
													fontWeight: 'bold',
													borderTopWidth: 0,
													borderBottomWidth: 1,
													borderLeftWidth: 0,
													textAlign: 'center',
												}}>
												S.No
											</td>
											<td style={{ fontWeight: 'bold', borderTopWidth: 0, borderBottomWidth: 1, textAlign: 'center' }}>
												Bill Date
											</td>
											<td style={{ fontWeight: 'bold', borderTopWidth: 0, borderBottomWidth: 1, textAlign: 'center' }}>
												Bill Amount
											</td>
											<td style={{ fontWeight: 'bold', borderTopWidth: 0, borderBottomWidth: 1, textAlign: 'center' }}>
												Delivery Fixed Date
											</td>
											<td
												style={{
													fontWeight: 'bold',
													borderTopWidth: 0,
													borderBottomWidth: 1,
													borderRightWidth: 0,
													textAlign: 'center',
												}}>
												<div style={{ paddingRight: 10 }}>Delivered Date</div>
											</td>
										</tr>
										{(data || [])?.map((data, index) => (
											<tr>
												<td
													style={{
														borderTopWidth: 0,
														borderBottomWidth: 0,
														// borderBottomWidth: index + 1 === 10 ? 0 : 1,
														borderLeftWidth: 0,
														textAlign: 'center',
														height: 30,
													}}>
													{data?.billNumber}
												</td>
												<td
													style={{
														borderTopWidth: 0,
														borderBottomWidth: 0,
														// borderBottomWidth: index + 1 === 10 ? 0 : 1,
														padding: 5,
														height: 30,
														textAlign: 'center',
													}}>
													{moment(data?.billDate).format(DATE_FORMAT.DD_MM_YYYY)}
												</td>
												<td
													style={{
														borderTopWidth: 0,
														borderBottomWidth: 0,
														// borderBottomWidth: index + 1 === 10 ? 0 : 1,
														padding: 5,
														height: 30,
														textAlign: 'right',
													}}>
													{(parseFloat(data?.totalAmount).toFixed(2))}
												</td>
												<td
													style={{
														borderTopWidth: 0,
														borderBottomWidth: 0,
														// borderBottomWidth: index + 1 === 10 ? 0 : 1,
														textAlign: 'center',
														height: 30,
													}}>
													{moment(data?.deliveryDate).format(DATE_FORMAT.DD_MM_YYYY)}
												</td>
												<td
													style={{
														borderTopWidth: 0,
														borderBottomWidth: 0,
														// borderBottomWidth: index + 1 === 10 ? 0 : 1,
														textAlign: 'center',
														height: 30,
													}}>
													{data?.deliveredDate ? moment(data?.deliveredDate).format(DATE_FORMAT.DD_MM_YYYY) : ''}
												</td>
											</tr>
										))}
									</table>
								</td>
							</tr>
							<tr style={{
									fontSize: '0.8rem',
									fontWeight: 'bold',
								}}>
								<td style={{ width: '50%' }}>
									<div className="content" style={{}}>
										<div>
											Printed by {loginRedux?.firstName} {loginRedux?.lastName}
										</div>
									</div>
									{/* <div className="content" style={{}}>
										<div>Printed on {getDateFormat(moment())}</div>
									</div> */}
								</td>
								<td colSpan={'2'} style={{ width: '50%' }}>
									{/* <div
										className="content"
										style={{
											display: 'flex',
											fontSize: '1rem',
											justifyContent: 'space-between',
										}}>
										<div className="title" style={{ textAlign: 'right' }}>
											Total Credit
										</div>
										<div className="title" style={{ textAlign: 'right' }}>
											{totalCredit}
										</div>
									</div>
									<div
										className="content"
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											fontSize: '1rem',
										}}>
										<div className="title" style={{ textAlign: 'right' }}>
											Total Debit
										</div>
										<div className="title" style={{ textAlign: 'right' }}>
											{totalDebit}
										</div>
									</div> */}
									<div className="content" style={{}}>
										<div>Printed on {getDateFormat(moment())}</div>
									</div>
								</td>
							</tr>
						</table>
					</td>
				</tr>
			</table>
		</div>
	);
});

export default DeliveryCheckingReportToPrint;
